import { render, staticRenderFns } from "./store-audit-space.vue?vue&type=template&id=3c2d11f1"
import script from "./store-audit-space.vue?vue&type=script&lang=js"
export * from "./store-audit-space.vue?vue&type=script&lang=js"
import style0 from "./store-audit-space.vue?vue&type=style&index=0&id=3c2d11f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports